module.exports = __webpack_public_path__ + "img/drone_06.201c05e7.jpg";